import { SelectPhotoModalComponent } from '../../modals/select-photo-modal/select-photo-modal.component';
import { LogoutService } from '../../../auth/components/auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../../shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UsersService } from '../../../management/components/tabs/components/users/users.service';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss']
})
export class ProfilePageComponent implements OnInit {
  image: any;
  uploadProgress: number | undefined;
  downloadURL: string | undefined;
  cameraImage: string = "assets/imgs/profile-placeholder.png";
  headerTitle = 'Profile Page'
  email: any;
  firstName:string='';
  userPic: any;
  role: any;
  phoneNo: any;
  user: any = {};
  userCreatedAt: any;
  blockLoader: string = "blockLoader";
  userName:any;

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private logoutService: LogoutService,
	private usersService: UsersService,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    public dialog: MatDialog
  ) {
    // this.afAuth.authState.subscribe(user => {
    //   this.user = user;
    // });
  }

  async ngOnInit() {
    this.getUser();
    await this.getUserFromCollection();
  }

  getUser() {
    this.email = localStorage.getItem('username');
    this.userName = localStorage.getItem('firstName');
    this.role = localStorage.getItem('roleId');
    this.userPic = localStorage.getItem('userPic');
    // this.phoneNo = localStorage.getItem('phoneNo');

		if(this.userName) {
			const fullName  = this.userName.split(" ");
			this.firstName = fullName[0];
		}
  }

  uploadImage(files: any) {
    // for (let i = 0; i < files.length; i++) {
    //   let reader = new FileReader();
    //   reader.readAsDataURL(files.item(i))
    //   reader.onload = async (event: any) => {
    //     this.userPic = event.target.result;
    //   }
    // }
  }

  async getUserFromCollection() {
    const userData = await this.logoutService.getUserByEmail(this.email);
    this.user = userData[0];
	this.user.role = await this.usersService.getRoleName(this.user.roleId);
    // console.log('user', this.user)
    if (this.user.createdAt) {
      this.userCreatedAt = this.user.createdAt.toDate().toUTCString();
    } else {
      this.userCreatedAt = new Date().toUTCString();
    }
  }

  onFileSelected(event: any): void {
    const inputElement = <HTMLInputElement>event.target;
    const files = inputElement.files;

    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        if (file) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async (event: any) => {
            this.image = event.target.result;
          };
        }
      }
    }

  }

  async updateProfile() {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      //   alert("Please login again. Some data needs to be updated.");
      this.snackbar.open("Please login again.");
      this.router.navigate(['login']);
    } else {
      if (this.image) {
        this.userPic = await this.sharedService.getUrlForUploadedFile(this.image, `users/${userId}/profilePicture/`);
        this.user = { ...this.user, userPic: this.userPic };
      }

      await this.spinner.show("blockLoader");
      await this.logoutService.updateUser(this.user.id, this.user);
      await this.spinner.hide("blockLoader");
      this.snackbar.open("Profile updated successfully!", "OK");
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(SelectPhotoModalComponent, {
      maxWidth: '30vw',
      // minWidth: 'fit-content',
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.image = result;
        this.user.userPic = result;
        await this.updateProfile();
        location.reload();
        // this.user = { ...this.user, userPic: result };
        // console.log(`Dialog result: ${result}`);
      }

    });
  }

	async deleteUserProgress() {
		const userId = localStorage.getItem('userId') ?? '';

		await this.spinner.show("blockLoader");
		const deletionRes = await this.usersService.deleteUserProgress(userId);
		await this.spinner.hide("blockLoader");

		if (deletionRes.status === 'success') {
			this.snackbar.open("Your progress from all programs has been deleted!", "OK");
			const allLocalStorageItems = {...localStorage};

			for (let key of Object.keys(allLocalStorageItems)) {
				if (key.startsWith("completion_")) {
					localStorage.removeItem(key);
				}
			}
		} else if (deletionRes.status === 'not-required') {
			this.snackbar.open("You are not enrolled in any program yet!", "OK");
		} else if (deletionRes.status === 'failed') {
			this.snackbar.open("Unable to delete progress for you!", "OK");
		}
	}

	isuserAdmin(userRole: string, userEmail: string) {
		return userRole === 'admin' && (userEmail === 'igniteadmin1@example.com' || userEmail === 'igniteadmin2@example.com' || userEmail === 'devadmin1@example.com' || userEmail === 'devadmin2@example.com' || userEmail === 'terry@terryhawkins.com');
	}
}
